const STATUS_CODES = {
  401: '401',
  403: '403',
};

export default STATUS_CODES;
